import classNames from 'classnames';

import React from 'react';

import { Helmet } from 'react-helmet';

import { useHistory, useLocation } from 'react-router-dom';

import { useShopConfig } from '../ShopConfig/ShopConfigContext';

interface OwnProps {
  threshold?: number;
}

type Props = React.PropsWithChildren<Readonly<OwnProps>>;

const ScrollToTop: React.FC<Props> = ({ threshold = 100, children }) => {
  const location = useLocation();
  const history = useHistory();
  const { canonicalUrl } = useShopConfig();
  const [scrolled, setScrolled] = React.useState(false);

  React.useEffect(() => {
    const handler = () => {
      setScrolled(window.scrollY > threshold);
    };

    window.addEventListener('scroll', handler, { passive: true });
    return () => {
      window.removeEventListener('scroll', handler);
    };
  }, []);

  React.useEffect(() => {
    if (history.action === 'PUSH' && !location.hash) window.scrollTo(0, 0);
  }, [location.pathname, history.action, location.hash]);

  React.useEffect(() => {
    if (!location.hash) return;
    const navbarHeight = 30 + document.querySelector('#header .navbar')?.clientHeight ?? 0;
    const element = document.getElementById(location.hash.substring(1));

    if (element) {
      const offsetTop = element.offsetTop || (element.offsetParent as HTMLElement).offsetTop;
      const targetOffset = Math.max(0, offsetTop - navbarHeight);
      window.scrollTo(0, targetOffset);
    }
  }, [location.hash]);

  const createCanonical = canonicalUrl && location.pathname && location.pathname !== '/';

  return (
    <>
      <Helmet>
        {createCanonical && <link rel="canonical" href={canonicalUrl + location.pathname} />}
        {scrolled && <body data-scrolled={false} />}
      </Helmet>
      {children}
    </>
  );
};

export default React.memo(ScrollToTop);
